@if (html) {
  <div
    class="inner-html"
    (click)="processLinks($event)"
    [innerHtml]="html | sanitizeHtml"
  ></div>
}
